module.exports = require('./helpers/bundle-url').getBundleURL('eW1DW') + "logo-dark.eefe0b7f.svg";